export const environment = {
  production: false,
  envName: 'mod',
  efnolBaseUrl:'https://apiccommodel.plymouthrock.com/model/claims/op/efnol/',
  fnolBaseUrl:'https://apiccommodel.plymouthrock.com/model/claims/op/fnol/',
  profileBaseUrl:'https://apiccommodel.plymouthrock.com/model/claims/op/profile/',
  configBaseUrl: 'https://apiccommodel.plymouthrock.com/model/claims/op/dynamicUi/',
  efnol1URL: 'http://efnolmod.plymouthrock.com/#/',
  KidTimeMin:60,
  IdleTimeMin:30,
  WarningTimeoutMin:2,
  GOOGLE_ANALYTICS_4_ID:	"G-35R56S8Q00",
};